import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconColorStyle({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M7.625.152a.545.545 0 0 1 .808.057l.1.108c.16.177.433.48.777.877l.27.314c1.785 2.096 4.92 6.107 4.92 8.451 0 3.323-2.915 6.026-6.5 6.026S1.5 13.282 1.5 9.96c0-2.345 3.135-6.356 4.922-8.452l.27-.314c.516-.595.874-.98.933-1.042zM8 1.216C5.665 3.794 2.5 7.961 2.5 9.96c0 2.772 2.465 5.026 5.5 5.026 3.03 0 5.5-2.254 5.5-5.027 0-1.993-3.165-6.17-5.5-8.743z"/>
        </svg>
    );
}

export default IconColorStyle;
